/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_VersionInputs */



/**
* | output |
* | --- |
* | "Installed version" |
*
* @param {License_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_version = /** @type {((inputs?: License_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Version installée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Installierte Version")
	if (locale === "it") return /** @type {LocalizedString} */ ("Versione installata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установленная версия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Versión instalada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已安装版本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インストール済みバージョン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इंस्टॉल किया गया संस्करण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Versão instalada")
	return /** @type {LocalizedString} */ ("Installed version")
});